import { MakeInlineWCCContentBlock } from 'components/content/mixins/inline';
import { MakeWCCContentBlockWithLimit } from 'components/content/mixins/limit';
import { DOMHelpers } from 'helpers/dom';
import { TextHelpers } from 'helpers/text';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { WCCContentBlock } from '../block/block';
import { WCCContentBlockConfig } from '../block/block.interfaces';

const maxLinkLength = 30;

export interface WCCContentLinkBlockConfig extends WCCContentBlockConfig {
    url: SubscribableOrNullableValue<string>
    protocol: SubscribableOrNullableValue<string>
    dns: SubscribableOrNullableValue<string>
}

function setupConfig(config: WCCContentLinkBlockConfig) {
    if (config.content.length > maxLinkLength)
        return _({}).extend(config, {
            content: TextHelpers.cutTextInTheMiddle(config.content, maxLinkLength)
        });

    return config;
}

const ExtendedWCCContentBlock = [
    MakeInlineWCCContentBlock,
    MakeWCCContentBlockWithLimit({ cut: TextHelpers.cutTextInTheMiddle, maxLength: maxLinkLength })
].reduce((result, mixin) => mixin(result), WCCContentBlock);

export class WCCContentLinkBlock extends ExtendedWCCContentBlock {
    url: Subscribable<string | undefined>

    constructor(config: WCCContentLinkBlockConfig) {
        super(setupConfig(config));

        this.url = ko.flattenComputed(config.url);
    }

    protected override getNodes() {
        return DOMHelpers.createBindedNodes(`<a target="_blank" data-bind="attr: { href: url }, text: title"></a>`, { url: this.url, title: this.content })
    }
}